// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TI-z","twoColumnImage":"UI-z"};